import { BaseSyntheticEvent, FC, ReactNode } from 'react';
import { Link } from 'react-router';
import { partTestId } from '@connect-x-app/shared-utils';
import classnames from 'classnames';

import { Spinner } from '../spinner/Spinner';

import './Button.scss';

type Props = {
  asText?: boolean;
  children: ReactNode;
  className?: string;
  disabled?: boolean;
  href?: string;
  isBorderless?: boolean;
  isOutline?: boolean;
  loading?: boolean;
  onClick?: (event?: BaseSyntheticEvent) => void;
  testId?: string;
  theme?: 'neutral' | 'primary' | 'negative' | 'dark';
  type?: 'button' | 'submit' | 'reset';
};

export const Button: FC<Props> = ({
  asText,
  children,
  className = '',
  disabled,
  href,
  isBorderless = false,
  isOutline = false,
  loading,
  onClick = () => {},
  testId,
  theme = 'neutral',
  type = 'button',
}) => {
  const cssClasses = classnames(asText ? 'as-text' : 'button', className, theme, {
    borderless: isBorderless,
    disabled,
    loading,
    outline: isOutline,
  });

  const renderSpinner = () => {
    if (!loading) {
      return null;
    }
    return (
      <div className="spinner-wrapper" data-test={partTestId(testId, 'spinner')}>
        <Spinner theme={(asText ?? isOutline) ? 'normal' : 'inversed'} />
      </div>
    );
  };

  if (href) {
    return (
      <Link className={cssClasses} data-test={testId} to={href}>
        <>
          {children}
          {renderSpinner()}
        </>
      </Link>
    );
  }
  return (
    <button className={cssClasses} data-test={testId} disabled={disabled} onClick={onClick} type={type}>
      {children}
      {renderSpinner()}
    </button>
  );
};
